<template>
	<div class="pageWrapper">
		<el-row>
			<el-col :span="10">
				<div class="panel actionPanel">
					<img class="logo" src="../assets/primaryLogo.svg" />
					<div class="resetPasswordForm">
						<h1 style="font-weight: bold">Request A Password Reset</h1>
						<p>Please enter your email to request a password reset.</p>
						<el-divider></el-divider>
						<el-alert
							v-if="requestSuccess"
							:closable="false"
							style="margin-bottom: 12px"
							title="Password reset request was successful"
							description="If this email address exists in our systems you will shortly recieve a reset link. Please check your inbox"
							type="success"
							show-icon
						>
						</el-alert>
						<el-alert
							v-if="requestError"
							:closable="false"
							style="margin-bottom: 12px"
							title="Error requesting password reset"
							:description="errorMessage"
							type="error"
							show-icon
						>
						</el-alert>
						<el-form
							ref="form"
							@keyup.native.enter="requestReset"
							:rules="formRules"
							label-position="top"
							label-width="100px"
							:model="resetPasswordForm"
						>
							<el-form-item prop="email" label="Email">
								<el-input
									type="email"
									placeholder="john.smith@acme.com"
									v-model="resetPasswordForm.email"
								></el-input>
							</el-form-item>
							<!-- Hidden form item required to prevent page reload when form has only one item -->
							<el-form-item style="display: none">
								<el-input></el-input>
							</el-form-item>
							<el-form-item>
								<el-button
									:disabled="!resetPasswordForm.email || !emailIsValid ? true : false"
									@click="requestReset"
									:loading="operationInProgress"
									style="width: 100%; margin-top: 12px"
									type="primary"
									>Request Password Reset</el-button
								>
							</el-form-item>
							<el-form-item>
								<div style="text-align: center">
									Don't have an account?
									<el-button @click="$router.push('/signup')" style="position: relative" type="text"
										>Sign up now <img class="underline" src="../assets/underline.svg"
									/></el-button>
								</div>
							</el-form-item>
						</el-form>
					</div>
				</div>
			</el-col>
			<el-col :span="14">
				<div class="panel contentPanel"><mediaCarousel /></div>
			</el-col>
		</el-row>
	</div>
</template>

<script>
import mediaCarousel from "../components/mediaCarousel.vue";
import { httpHelper } from "../utils/httpHelper.js";
let $this;
export default {
	components: {
		mediaCarousel,
	},
	data() {
		const validateEmail = function (rule, value, callback) {
			var re =
				/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
			if (!re.test(String(value).toLowerCase())) {
				callback(new Error("Please enter a valid email"));
				$this.emailIsValid = false;
			} else {
				callback();
				$this.emailIsValid = true;
			}
		};
		return {
			emailIsValid: false,
			errorMessage: "An unknown error occured",
			requestSuccess: false,
			requestError: false,
			operationInProgress: false,
			resetPasswordForm: { email: "" },
			formRules: {
				email: [
					{ required: true, message: "Your email is required", trigger: "change" },
					{ validator: validateEmail, trigger: "change" },
				],
			},
		};
	},
	beforeMount() {
		$this = this;
	},
	methods: {
		requestReset() {
			this.requestError = false;
			this.requestSuccess = false;
			this.$refs.form.validate(async (valid) => {
				if (valid) {
					this.operationInProgress = true;
					const result = await httpHelper(
						"RUNTIME",
						"POST",
						"security/passwordResetRequest",
						this.resetPasswordForm
					);
					setTimeout(() => {
						this.operationInProgress = false;
						if (!result?.error) {
							this.requestSuccess = true;
							this.requestError = false;
						} else {
							if (result.status === 404) {
								this.errorMessage = "No account with this email exists";
								this.requestSuccess = false;
								this.requestError = true;
							} else {
								this.errorMessage = "An unknown error occured";
								this.requestSuccess = false;
								this.requestError = true;
							}
						}
					}, 500);
				} else {
					return;
				}
			});
		},
	},
};
</script>

<style scoped>
.pageWrapper {
	height: 100vh;
	width: 100vw;
	text-align: left;
}

.panel {
	height: 100vh;
	width: 100%;
}

.logo {
	height: 40px;
	margin-left: 20px;
	margin-top: 20px;
}

.actionPanel {
	background-color: white;
}

.contentPanel {
	background-color: #f5f7f9;
}

.resetPasswordForm {
	width: 70%;
	max-width: 400px;
	display: block;
	margin: auto;
	margin-top: 15%;
}

.underline {
	height: 8px;
	position: absolute;
	top: 35px;
	left: 0px;
}
</style>
